module.exports = __webpack_public_path__ + "static/media/21ECLAC28.f3bfcd63.jpg";